import { Profession } from '../../models/profession';
import { Race } from '../../models/race';
import { Skill } from '../../models/skill';
import data from './data.json';

let skills = (data.skills as unknown as Skill[]); //.filter(x => !x.defunct);
const races = data.races as unknown as Race[];
const professions = data.professions as unknown as Profession[];
const rates = data.rates as unknown as { [key: number]: number[] };

skills.forEach((v, i) => v.idNum = i + 1);
races.forEach((v, i) => v.idNum = i + 1);
professions.forEach((v, i) => v.idNum = i + 1);

class SkillTrainerData {
  getSkills(): Skill[] {
    return skills;
  }
  
  getRaces(): Race[] {
    return races;
  }

  getProfessions() {
    return professions;
  }

  getRates() {
    return rates;
  }

  getPracGainsByRace() {
    return races.reduce((p, c) => {
      p[c.id] = c.pracGain;
      return p;
    }, {} as { [raceId: string]: number });
  }

  getPracCostsByProfession() {
    return professions.reduce((p, c) => {
      p[c.id] = c.pracCost;
      return p;
    }, {} as { [professionId: string]: { [key: string]: number } })
  }
}

for (let skill of skills) {
  skill.percentStart = 0;
  skill.percentTarget = 0;  
  skill.percentActual = 0;
  skill.pracsActual = 0;
  skill.pracsCount = 0;
  skill.percentHistory = [];  
}

skills = skills.filter(x => !x.defunct);
for (let skill of skills) {
  const professionIds: string[] = [];
  for (let residualId of skill.residualIds ?? []) {
      const professionId = skills.find(x => x.id === residualId)?.professionId;
      if (professionId && professionId !== skill.professionId && !professionIds.includes(professionId)) {
        professionIds.push(professionId);
      }
  }
  skill.residualProfessionIds = professionIds;
}

export const skillTrainerData = new SkillTrainerData();